import { string } from 'prop-types';
import React from 'react';

import { DEFAULT_COLORS } from 'constants/colors';

const NavigationBackIcon = ({ fill, height, width }) => (
    <svg width={width} height={height} fill="none">
        <path
            d="M19 12H5M12 19l-7-7 7-7"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

NavigationBackIcon.propTypes = {
    fill: string,
    height: string,
    width: string,
};

NavigationBackIcon.defaultProps = {
    fill: DEFAULT_COLORS.BLACK,
    width: '20',
    height: '20',
};

export default NavigationBackIcon;
